document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {
        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;
    });

    let columnsSwiper = document.querySelectorAll(".columns-slider__slider");
    if(columnsSwiper){
        columnsSwiper.forEach((item)=>{
            new Swiper(".columns-slider__slider#"+item.id,{
                loop: true,
                slidesPerView: 1,
                spaceBetween: 0,
                navigation: {
                    nextEl: ".columns-slider__slider-next#"+item.id,
                    prevEl: ".columns-slider__slider-prev#"+item.id,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 4,
                        spaceBetween: 35,
                    },
                },
            })
        });
    }

    let sliderTwoImagesSwiper = document.querySelectorAll(".slider-two-images__right-slider");
    if(sliderTwoImagesSwiper){
        sliderTwoImagesSwiper.forEach((item)=>{
            new Swiper(".slider-two-images__right-slider#"+item.id,{
                loop: true,
                slidesPerView: 2.2,
                spaceBetween: 10,
                centeredSlides: true,
                navigation: {
                    nextEl: ".slider-two-images__right-slider-next#"+item.id,
                    prevEl: ".slider-two-images__right-slider-prev#"+item.id,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 2.4,
                        spaceBetween: 5,
                        centeredSlides: false,
                    },
                },
            })
        });
    }
});